module.exports = __webpack_public_path__ + "media/images/icon-plus-yellow-cdebc0b5edb0afceb77b54b6572d5ad1.svg";